import { unstable_cache } from 'next/cache';
import { SearchResponses, SearchResponse } from 'algoliasearch';

import { searchClient } from '@/lib/search/algolia';
import { SearchHit, SearchResultsByCategory } from '@/lib/models/Search';
import { INDEX_NAME } from '@/lib/constants/Search';
import { HELPDESK_TAGS } from '@/lib/constants/HelpdeskModuleTags';
import { fetchSearchResults } from '@/lib/utils/fetchSearchResults';

export async function getTopSearches(locale: string): Promise<SearchHit[]> {
  return unstable_cache(
    async () => {
      const response: SearchResponses = await searchClient.search([
        {
          indexName: INDEX_NAME,
          query: '',
          hitsPerPage: 5,
          analytics: true,
          distinct: 1,
          facetFilters: [[`language:${locale}`]],
        },
      ]);

      // @ts-ignore
      return (response.results[0] as SearchResponse<SearchHit>)?.hits ?? [];
    },
    [`top-searches-${locale}`],
    {
      tags: HELPDESK_TAGS,
    }
  )();
}

export async function getSearchResults(query: string, locale: string): Promise<SearchResultsByCategory> {
  return fetchSearchResults(query, locale);
}

export function getSearchResultsCached(query: string, locale: string): Promise<SearchResultsByCategory> {
  return unstable_cache(() => fetchSearchResults(query, locale), [`search-results-${query}-${locale}`], {
    revalidate: 300,
    tags: HELPDESK_TAGS,
  })();
}
